import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import ErrorBoundary from './components/ErrorBoundary'

// Components
import Header from './components/Header'
import Footer from './components/Footer'
import ProtectedRoute from './components/ProtectedRoute'
import SecurityTest from './components/SecurityTest'

// Pages
import Home from './pages/Home'
import About from './pages/About'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import NotFound from './pages/NotFound'

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard'
import AdminLogin from './pages/admin/Login'
import AdminBlogPosts from './pages/admin/BlogPosts'
import AdminCreatePost from './pages/admin/CreatePost'
import AdminEditPost from './pages/admin/EditPost'
import AdminCategories from './pages/admin/Categories'

function App() {
  return (
    <ErrorBoundary>
      <Helmet>
        <title>Blog Website</title>
        <meta name="description" content="A secure blog website" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      </Helmet>
      <Header />
      <main className="container">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/security-test" element={<SecurityTest />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/posts" 
            element={
              <ProtectedRoute>
                <AdminBlogPosts />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/posts/create" 
            element={
              <ProtectedRoute>
                <AdminCreatePost />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/posts/edit/:id" 
            element={
              <ProtectedRoute>
                <AdminEditPost />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/categories" 
            element={
              <ProtectedRoute>
                <AdminCategories />
              </ProtectedRoute>
            } 
          />
          
          {/* 404 Page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </ErrorBoundary>
  )
}

export default App 